import { get, values } from 'lodash'

export const getVenues = state => values(get(state, ['venues', 'byId']))

export const getCurrentVenueUuid = state => get(state, ['venues', 'selectedId'])

export const getCurrentVenue = state => get(state, ['venues', 'byId', getCurrentVenueUuid(state)], {})

export const getCurrentVenueTimezone = state => {
  const currentVenue = getCurrentVenue(state)
  const currentVenueTimezone = currentVenue?.timeZone

  return currentVenueTimezone
}
